import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';
import { AlertTriangle } from 'lucide-react-native';
import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { twJoin } from 'tailwind-merge';

import { Alert, AlertIcon, AlertText } from '@/components/ui/alert';
import { MAINTENANCE } from '@/constants/maintenance';
import { useMaintenanceMode } from '@/hooks/useMaintenanceMode';

/**
 * Site-wide maintenance banner displayed at the top of the app.
 * Shows when maintenance_mode feature flag is enabled in Flagsmith.
 *
 * Positioned absolutely at the top, similar to the offline banner,
 * to ensure visibility across all pages and routes.
 */
export function MaintenanceBanner() {
  const isMaintenanceMode = useMaintenanceMode();

  const { top } = useSafeAreaInsets();

  if (!isMaintenanceMode) {
    return null;
  }

  return (
    <Alert
      variant="solid"
      action="warning"
      className={twJoin(
        'absolute z-[60] w-full flex-row items-center justify-center',
        isWeb ? 'sticky top-0' : ''
      )}
      style={{
        paddingTop: Platform.OS === 'ios' ? top : 12,
      }}>
      <AlertIcon as={AlertTriangle} />

      <AlertText size="md">
        <AlertText size="md" bold>
          {MAINTENANCE.BANNER.title}{' '}
        </AlertText>
        {MAINTENANCE.BANNER.description}
      </AlertText>
    </Alert>
  );
}
